module.exports = __webpack_public_path__ + "assets/bg-qr-code-08f842df.png";